// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IModelResponse, IModel } from '@cian/http-api';
import type { IGetRealtorsResponseSchema } from '../../entities/get_agents/GetRealtorsResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetRealtorsRequest {
  /** Регион поиска **/
  regionId: number;
  /** Поисковый запрос **/
  searchText?: string;
  /** Тип сделки **/
  dealType?: EDealType;
  /** Тип недвижимости **/
  offerType?: EOfferType[];
  /** Тип сортировки **/
  sortBy?: ESortBy;
  /** Номер запрашиваемой страницы **/
  page?: number;
  /** Кол-во элементов на странице **/
  limit?: number;
}
export enum EDealType {
  /** Аренда **/
  'Rent' = 'rent',
  /** Продажа **/
  'Sale' = 'sale',
}
export enum EOfferType {
  /** Коммерческая **/
  'Commercial' = 'commercial',
  /** Жилая **/
  'Flat' = 'flat',
  /** Загородная **/
  'Suburban' = 'suburban',
}
export enum ESortBy {
  /** По времени на Циан **/
  'Age' = 'age',
  /** По имени/названию **/
  'Name' = 'name',
  /** По количеству объявлений **/
  'OffersCount' = 'offersCount',
}

export type IGetRealtorsResponse = IGetRealtorsResponseSchema;

export interface IGetRealtorsResponse200 extends IModelResponse<IGetRealtorsResponse> {
  statusCode: 200;
}

export type IGetRealtorsResponseError = IErrorResponseSchema;

export interface IGetRealtorsResponse400 extends IModelResponse<IGetRealtorsResponseError> {
  statusCode: 400;
}

export type TGetRealtorsResponse = IGetRealtorsResponse200 | IGetRealtorsResponse400;

export type TGetRealtorsModel = IModel<IGetRealtorsRequest, TGetRealtorsResponse>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetRealtorsResponse): TResponse200;
  400(response: IGetRealtorsResponseError): TResponse400;
}
